export const POLICY_CONFIG_FILE_NAME: string = 'client-config-policy-config'
export const POLICY_CONFIG_PATH: string = 'policies'

export const SETTINGS_CONFIG_FILE_NAME: string = 'client-config-settings-config'
export const SETTINGS_CONFIG_PATH: string = 'settings'
